"use client";
import { Header } from "@/components/header";
import { RoomComponent } from "@/components/room-component";
import { useState, useEffect } from "react";
import { decryptValue, getQueryParam } from "./utility/utilities";
// import Smartlook from 'smartlook-client' 
// import { Auth } from "@/components/auth";
// import LK from "@/components/lk";
export default function Dashboard() {
  const [isNewLayout, setIsNewLayout] = useState(false); // Variable to toggle layouts
  
  // useEffect(() => {
  //   if(getQueryParam("env").includes('clients')) {
  //     Smartlook.init('020af9619b8b0d73149301e57ee8c809e2c41c1a');
  //     Smartlook.identify(getQueryParam('part_code'), {
  //       'tour_id': getQueryParam('tour_id'),
  //       'participant_name': getQueryParam('p_name')
  //     });
  //   }
  // }, []);
  
  useEffect(() => {
    if (decryptValue(getQueryParam("type")) === "video") {
      setIsNewLayout(true);
    } else {
      setIsNewLayout(false);
    }
  }, []);

  return (
    <div className="flex flex-col h-full bg-neutral-100">
      {/* <header className="flex flex-shrink-0 h-6 items-center justify-between px-4 w-full md:mx-auto"> */}
      {/* <LK /> */}
      {/* </header> */}
      <main className="flex flex-col flex-grow overflow-hidden p-0 md:pt-0 w-full md:mx-auto">
        {!isNewLayout && <Header isNewLayout={isNewLayout} />}
        <RoomComponent
          isNewLayout={isNewLayout}
          Header={Header}
          setIsNewLayout={setIsNewLayout}
        />
      </main>
    </div>
  );
}
